import { CloseIcon, NewIcon, UpdateIcon } from '@synergy/theme';

import { ImportChangeState } from '../models/import-change-state';

export const getImportStatusIcon = (status: ImportChangeState) => {
    const style = {
        fontSize: 20,
    };

    switch (status) {
        case 'CHANGE_STATE_NEW':
            return <NewIcon style={style} />;
        case 'CHANGE_STATE_CHANGED':
            return <UpdateIcon style={style} />;
        case 'CHANGE_STATE_DELETE':
            return <CloseIcon style={style} />;
        case 'CHANGE_STATE_UNCHANGED':
            return null;
        default:
            return null;
    }
};
